import { Stack } from '@mui/material'
import { KeyboardArrowLeft } from '@mui/icons-material'
import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../hooks/useTexts'
import { Footer } from './Footer'

export function ConfigureColumnsFooter() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const { close, status, invalid } = useController()

  return (
    <Footer>
      <ModalFooterButton onClick={handlers.backToConfigureFormat} testid="modal-tertiary-button">
        <KeyboardArrowLeft />
        {texts.prevStepButton}
      </ModalFooterButton>
      <Stack gap={1} direction="row">
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButton}
        </ModalFooterButton>
        <ModalFooterButton
          disabled={invalid || status !== 'ready'}
          onClick={handlers.onExport}
          variant="contained"
          loading={handlers.isLoading}
          testid="modal-primary-button"
        >
          {texts.exportButton}
        </ModalFooterButton>
      </Stack>
    </Footer>
  )
}
